import { makeStyles } from '@material-ui/styles'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import { GRIN_ALL_INCLUSIVE_GROUP, GRIN_SUBSCRIPTION_GROUP } from 'consts/grinPlanConsts'
import useClinic from 'hooks/useClinic'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ScopesDiscount from 'resources/scopes-discount.png'
import ScopesDiscountSubV3 from 'resources/scope-discount-subscription-v3.png'

const useStyles = makeStyles(theme => ({}))

const OrderExtraInfo = ({ grinPlanGroup, shippingFee }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { hasFreeScopes } = useClinic()

  const hasAnyDiscount =
    (grinPlanGroup.includes(GRIN_SUBSCRIPTION_GROUP) || grinPlanGroup.includes(GRIN_ALL_INCLUSIVE_GROUP)) &&
    !hasFreeScopes

  const getDiscountAsssetByPlanGroup = planGroup => {
    if (planGroup.includes(GRIN_SUBSCRIPTION_GROUP)) {
      return ScopesDiscount
    }

    return ScopesDiscountSubV3
  }

  return hasAnyDiscount ? (
    <img src={getDiscountAsssetByPlanGroup(grinPlanGroup)} alt="" />
  ) : (
    <DazzedParagraph12 className={classes.note}>
      {t('dialogs.orderScopes.shippingFeeText1')}
      <span className={classes.currencyPrefix}>&nbsp;$</span>
      {t('dialogs.orderScopes.shippingFeeText2', {
        fee: `${shippingFee} USD`
      })}
    </DazzedParagraph12>
  )
}

export default OrderExtraInfo
